import { render, staticRenderFns } from "./asset-actions-footer.vue?vue&type=template&id=6c742908&scoped=true&"
import script from "./asset-actions-footer.vue?vue&type=script&lang=js&"
export * from "./asset-actions-footer.vue?vue&type=script&lang=js&"
import style0 from "./asset-actions-footer.vue?vue&type=style&index=0&id=6c742908&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c742908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c742908')) {
      api.createRecord('6c742908', component.options)
    } else {
      api.reload('6c742908', component.options)
    }
    module.hot.accept("./asset-actions-footer.vue?vue&type=template&id=6c742908&scoped=true&", function () {
      api.rerender('6c742908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/details-asset/asset-actions-footer.vue"
export default component.exports